import { ModelType } from '@dimjs/model';
import { getFullUrlHref } from '../utils/path.js';
import {
  FabricException,
  FabricExceptionItem,
  FabricMultiExceptionItems,
} from './fabric-exception.js';

export type ExceptionModelState = {
  stack: {
    [routePath: string]: Record<string, FabricExceptionItem>;
  };
  globalError: {
    [routePath: string]: { error: FabricMultiExceptionItems };
  };
};

export type ExceptionModelActionParams = {
  setException: {
    urlHref: string;
    id: string;
    exception: Error | FabricException;
  };
  resetException: string;
  traceGlobalException: { urlHref: string; error?: FabricMultiExceptionItems };
};

function prepareExceptionCtx(state: ExceptionModelState, urlHref: string) {
  if (!state.stack[urlHref]) {
    state.stack[urlHref] = {};
  }
  if (!state.globalError[urlHref]) {
    state.globalError[urlHref] = {
      error: null,
    };
  }
}

export const FabricExceptionModel: ModelType<
  ExceptionModelState,
  ExceptionModelActionParams
> = {
  actions: {
    setException: ({ urlHref, exception, id }) => {
      return (state) => {
        // if current need to show global exception while `hooks.useModelEffectAsync()`
        // simply ignore biz exceptions here.
        prepareExceptionCtx(state, urlHref);
        state.stack[urlHref][id] = exception;
      };
    },
    resetException: (id) => {
      const urlHref = getFullUrlHref();
      return (state) => {
        prepareExceptionCtx(state, urlHref);
        state.stack[urlHref][id] = null;
        delete state.stack[urlHref][id];
      };
    },
    traceGlobalException({ urlHref, error }) {
      return (state) => {
        prepareExceptionCtx(state, urlHref);
        state.globalError[urlHref].error = error;
      };
    },
  },
  state: {
    stack: {
      [getFullUrlHref()]: {},
    },
    globalError: { [getFullUrlHref()]: { error: null } },
  },
};
